/**
 * Vendors A-Z Navigation
 * Handles navigation for vendor slideshow components
 */

(function() {
  function initVendorsNavigation() {
    // Find all navigation containers
    const navigations = document.querySelectorAll('.vendors-navigation[data-slideshow-id]');
    
    navigations.forEach(nav => {
      const slideshowId = nav.getAttribute('data-slideshow-id');
      const slideshow = document.querySelector(`slideshow-component[ref="${slideshowId}"]`);
      
      if (!slideshow) {
        console.log('Slideshow not found for:', slideshowId);
        return;
      }
      
      if (!slideshow.select) {
        console.log('Slideshow select method not available for:', slideshowId);
        return;
      }
      
      // Find buttons only within this navigation
      const buttons = nav.querySelectorAll('.vendors-navigation__button--active[data-slide-id]');
      
      buttons.forEach(button => {
        button.addEventListener('click', function() {
          const slideId = this.getAttribute('data-slide-id');
          console.log('Navigating to slide:', slideId, 'in slideshow:', slideshowId);
          slideshow.select({ id: slideId });
        });
      });
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVendorsNavigation);
  } else {
    // Wait a bit for custom elements to be defined
    setTimeout(initVendorsNavigation, 100);
  }
})();
